<template>
  <bar-widget
    :key="`${widgetKey}-${selectedOption.text}-${upd}${valueAppend}`"
    :widget-key="`${widgetKey}-${selectedOption.text}-${upd}${valueAppend}`"
    :data="selectedData"
    :loading="loading"
    :value-append="valueAppend"
  >
    <template v-slot:title>
      <div class="pl-1 mb-1 mw-100">
        <b-dropdown
          variant="link"
          toggle-class="p-0 mw-100"
          class="mw-100"
          no-caret
        >
          <template #button-content>
            <div class="d-flex align-items-center mw-100">

              <h5 class="heading text-heavy mb-0 text-truncate">
                {{ selectedOption.text }}
              </h5>
              <GjIcon
                class="icon-right"
                name="ArrowDown"
                size="17"
              />
            </div>
          </template>
          <template v-for="item in widgetOptions">
            <b-dropdown-item
              :key="item.id"
              @click="() => {
                selectedOption=item;
                upd +=1
              }"
            >
              {{ item.text }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </div>
    </template>
  </bar-widget>
</template>

<script>
import BarWidget from './BarWidget.vue'

export default {
  name: 'QualityAverages',
  components: {
    BarWidget,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Array,
      default: () => [],
    },
    widgetKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      upd: 0,
      selectedOption: {
        id: 0,
        text: 'Qualities',
      },
      widgetOptions: [
        {
          id: 0,
          text: 'Qualities',
        },
        {
          id: 1,
          text: 'Average Quality Encoding Time',
        },
      ],
    }
  },
  computed: {
    selectedData() {
      return this.selectedOption.id === 0 ? this.data.map(q => ({ name: q.quality, count: q.numberOfQualities }))
        : this.data.map(q => ({ name: q.quality, count: q.averageTimeEncodingQuality }))
    },
    valueAppend() {
      return this.selectedOption.id === 1 ? ' minutes' : ''
    },
  },

}
</script>

<style>

</style>
